<!-- 优秀论文：论文评优 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.75">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.15" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.15" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="27.75" y1="16.64" x2="27.75" y2="10.63" />
        <path
          class="cls-3"
          d="M16.7,28.3H6.94a1.74,1.74,0,0,1-1.76-1.72V2.76A1.74,1.74,0,0,1,6.94,1H26a1.74,1.74,0,0,1,1.76,1.72"
        />
        <path
          class="cls-3"
          d="M24.67,17l6,.75a.08.08,0,0,1,0,.14l-4.22,4.2a.08.08,0,0,0,0,.08L27.65,28a.09.09,0,0,1-.12.09l-5.42-2.66H22l-5.28,2.85a.08.08,0,0,1-.12-.09l.87-5.85a.11.11,0,0,0,0-.07L13,18.22a.09.09,0,0,1,.05-.15L19,17.12a.12.12,0,0,0,.07-.05l2.53-5.35a.09.09,0,0,1,.15,0L24.61,17A.07.07,0,0,0,24.67,17Z"
        />
        <line class="cls-3" x1="8.71" y1="6.45" x2="16.53" y2="6.45" />
        <line class="cls-3" x1="9.02" y1="12.92" x2="12.1" y2="12.92" />
        <ellipse class="cls-4" cx="27.77" cy="6.18" rx="1.31" ry="1.28" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 36.75">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.15" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.15" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="27.75" y1="16.64" x2="27.75" y2="10.63" />
        <path
          class="cls-3"
          d="M16.7,28.3H6.94a1.74,1.74,0,0,1-1.76-1.72V2.76A1.74,1.74,0,0,1,6.94,1H26a1.74,1.74,0,0,1,1.76,1.72"
        />
        <path
          class="cls-3"
          d="M24.67,17l6,.75a.08.08,0,0,1,0,.14l-4.22,4.2a.08.08,0,0,0,0,.08L27.65,28a.09.09,0,0,1-.12.09l-5.42-2.66H22l-5.28,2.85a.08.08,0,0,1-.12-.09l.87-5.85a.11.11,0,0,0,0-.07L13,18.22a.09.09,0,0,1,.05-.15L19,17.12a.12.12,0,0,0,.07-.05l2.53-5.35a.09.09,0,0,1,.15,0L24.61,17A.07.07,0,0,0,24.67,17Z"
        />
        <line class="cls-3" x1="8.71" y1="6.45" x2="16.53" y2="6.45" />
        <line class="cls-3" x1="9.02" y1="12.92" x2="12.1" y2="12.92" />
        <ellipse class="cls-4" cx="27.77" cy="6.18" rx="1.31" ry="1.28" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 36.97">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.38" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.38" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="27.24" y1="16.64" x2="27.24" y2="10.63" />
        <path
          class="cls-3"
          d="M16.2,28.3H6.44a1.75,1.75,0,0,1-1.76-1.73V2.76A1.74,1.74,0,0,1,6.44,1h19a1.74,1.74,0,0,1,1.76,1.72"
        />
        <path
          class="cls-3"
          d="M24.17,17l6,.74a.08.08,0,0,1,.05.14L26,22.11a.08.08,0,0,0,0,.07L27.14,28c0,.07-.05.12-.12.09l-5.41-2.66a.11.11,0,0,0-.08,0l-5.28,2.85a.08.08,0,0,1-.12-.09L17,22.34a.11.11,0,0,0,0-.08l-4.43-4.05a.08.08,0,0,1,.05-.14l5.95-1a.07.07,0,0,0,.06,0l2.54-5.35a.09.09,0,0,1,.15,0L24.1,17S24.14,17,24.17,17Z"
        />
        <line class="cls-3" x1="8.21" y1="6.45" x2="16.03" y2="6.45" />
        <line class="cls-3" x1="8.52" y1="12.92" x2="11.6" y2="12.92" />
        <ellipse class="cls-4" cx="27.26" cy="6.18" rx="1.31" ry="1.27" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.07px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.07px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #1ba586;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.07px;
    }
    .cls-4 {
      fill: #1ba586;
    }
  }
</style>
